export default __webpack_public_path__ + "static/media/car_image.9c2e29fd.png";